var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from "vuex";
import AccoutCheckService from '../../../api/AccoutCheckService';
import CommonService from '../../../api/CommonService';
var initFormData = {
    is_confirm: "",
    order_status: -1,
    keyword_type: 1,
    s_time: new Date(Date.now() - 30 * 24 * 3600 * 1000),
    e_time: new Date(),
    order_type: '',
    depot_ids: ['-1']
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.depot_list = [];
        _this.formData = __assign({}, initFormData);
        _this.type = [{
                id: 1,
                label: "客户名称"
            },
            {
                id: 3,
                label: "对账单号"
            }, {
                id: 4,
                label: "业务单号"
            }];
        _this.confirmStatus = [{
                id: "",
                text: "全部"
            }, {
                id: "1",
                text: "已确认"
            }, {
                id: "0",
                text: "待确认"
            }, {
                id: "2",
                text: "已驳回"
            }];
        _this.options = [];
        _this.orderTypeOptions = [{
                id: "",
                text: "全部"
            }, {
                id: "1",
                text: "供应链"
            }, {
                id: "4",
                text: "代客下单"
            }];
        return _this;
    }
    BillHeader.prototype.search = function () {
        var params = __assign({}, this.formData);
        params.depot_ids = params.depot_ids.join(',');
        this.$emit('search', params);
    };
    BillHeader.prototype.initDepot = function () {
        var _this = this;
        var params = {
            organ_id: '',
            is_self: 1
        };
        this.commonService.getSupplierdepotOptions(params).then(function (res) {
            console.log('------initDepot', res);
            _this.depot_list = res.data.data || [];
        }).finally(function () {
            _this.depot_list = [{ depot_id: '-1', depot_name: '所有仓库' }].concat(_this.depot_list);
        });
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
    };
    BillHeader.prototype.mounted = function () {
        var _this = this;
        this.initDepot();
        this.service.getStatus().then(function (res) {
            _this.options = res.data.data;
            console.log('this.options', _this.options);
        });
    };
    BillHeader.prototype.created = function () {
        this.service = AccoutCheckService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    BillHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                isErp: 'isErp'
            }))
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
